import React, { useEffect, useState } from "react";
import {
  ConnectWallet,
  useConnectWallet,
} from "@newm.io/cardano-dapp-wallet-connector";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://claiming.kwicdashboard.io";

const CardanoWalletButton = () => {
  const { wallet, getAddress, isConnected, error } = useConnectWallet();

  const [address, setAddress] = useState("");
  const [lovelace, setLovelace] = useState(null); // string | null
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!wallet) return;

    getAddress(async (addr) => {
      setAddress(addr);
      localStorage.setItem("connected_wallet_address", addr);
      localStorage.setItem("connected_wallet_name", wallet?.name || "");

      try {
        setLoading(true);
        const r = await fetch(`${BACKEND}/address-balance/${addr}`);
        const data = await r.json();
        setLovelace(data?.lovelace ?? "0");
      } catch (e) {
        console.warn("Failed to fetch lovelace:", e);
        setLovelace(null);
      } finally {
        setLoading(false);
      }
    });
  }, [wallet, getAddress]);

  // Format (switch to ADA if you prefer)

  const labelText = loading ? "…" : `₳${(Number(lovelace ?? 0)/1_000_000).toLocaleString()}`;

  return (
    <div
      className={`wallet-button-wrapper ${isConnected ? "is-connected" : "is-disconnected"}`}
      style={{ display: "inline-block", position: "relative" }}
    >
      <ConnectWallet
        onConnect={(w) => localStorage.setItem("last_wallet_id", w?.id || "")}
        onDisconnect={() => {
          localStorage.removeItem("connected_wallet_address");
          localStorage.removeItem("connected_wallet_name");
          localStorage.removeItem("last_wallet_id");
          setAddress("");
          setLovelace(null);
        }}
        onError={(msg) => console.warn("Wallet error:", msg)}
      />

      {isConnected && (
        <span
          className="wallet-balance-overlay"
          aria-label={labelText}
          style={{
            position: "absolute",
            inset: 0,
			fontSize: 17,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none", // keep button clickable
			padding: 20,
            color: "#fff",
            textTransform: "uppercase",
          }}
        >
          {labelText}
        </span>
      )}

      {!!error && (
        <span style={{ color: "crimson", fontSize: 12, marginLeft: 8 }}>{error}</span>
      )}
    </div>
  );
};

export default CardanoWalletButton;
